<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 178px;

  .plane {
    // padding-top: 5px;

    .patrol {
      padding: 0 20px;
      width: 100%;
      margin-top: 26px;
      display: flex;
      justify-content: space-between;
      .patrol_left {
        width: 189px;
        height: 80px;
        display: grid;
        grid-template-columns: repeat(6,28px);
        gap: 8px 4px;
        margin-right: 5px;
        div{
          display: flex;
          justify-content: center;
          align-items: center;
          background: rgba(255, 255, 255, 0.1);;
        }
        div:nth-child(9){
          grid-column: span 4;
          justify-content: flex-end;
          padding-right: 5px;
        }
      }
      .patrol_right{
        width: 200px;
        display: flex;
        justify-content: space-between;
        .data{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          p:nth-child(1){
            font-size: 18px;
            width: 88px;
            text-align: center;
          }
          .zc{
            font-family: "dina";
            font-size: 48px;
            color: #2D82FF;
          }
          .yc{
            font-family: "dina";
            font-size: 48px;
            color: #F1802F;
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane title="巡更管理" class="plane"
      :iconImg="require('@/assets/compImg/icon/patrol.png')">
      <div class="patrol">
        <div class="patrol_left">
          <div v-for="(item,index) in numb" :key="index">
              {{item}}
          </div>
        </div>
        <div class="patrol_right">
          <div class="data">
            <p>正常数量</p>
            <p class="zc">{{xgNum1}}</p>
          </div>
          <div class="data">
            <p>异常数量</p>
            <p class="yc">{{xgNum2}}</p>
          </div>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data(){
    return{
      numb:['01','02','03','04','05','06','07','08','09']
    }
  },
  props:{
    xgNum1:Number,
    xgNum2:Number
  }
}
</script>
